import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const feedbackRoutes = [
  {
    key: "feedback-list",
    exact: true,
    path: `${APP_PREFIX_PATH}/feedback/feedback-list`,
    component: React.lazy(() => import("views/app-views/feedback/pages/FeedbackList")),
  },
  {
    key: "feedback-create",
    exact: true,
    path: `${APP_PREFIX_PATH}/feedback/feedback-create`,
    component: React.lazy(() => import("views/app-views/feedback/pages/CreateFeedback")),
  },
  {
    key: "feedback-questions",
    exact: true,
    path: `${APP_PREFIX_PATH}/feedback/feedback-questions`,
    component: React.lazy(() => import("views/app-views/feedback/pages/FeedbackQuestionsList")),
  },
  {
    key: "feedback-summary",
    exact: true,
    path: `${APP_PREFIX_PATH}/feedback/feedback-summary/:id`,
    component: React.lazy(() => import("views/app-views/feedback/pages/FeedbackSummary")),
  },
];
